import { InjectionToken } from '@angular/core';
import { AppType } from '../shared/Enums';

export const CURRENT_APP_TYPE = new InjectionToken<AppType>('CurrentAppType');
